import React from 'react';
import ProjectList from '../components/ProjectList';
import PageHeader from '../components/common/PageHeader';
import PageContainer from '../components/common/PageContainer';

function Projects() {
  return (
    <PageContainer>
      <PageHeader title="案件管理" />
      <ProjectList />
    </PageContainer>
  );
}

export default Projects;
